export const menuBarIndex = {
    Welcome: -1,
    About: 0,
    Experience: 1,
    Skills: 2,
    Education: 3,
    Work: 4,
    Contact: 5,
};

// Pages that stay routable but have no side bar button
export const hiddenMenuBtns = ["Work"];

// Skills (index 2) is intentionally left empty so it has no menu button or route
// eslint-disable-next-line no-sparse-arrays
export const menuBtns = ["About", "Experience", , "Education", "Work", "Contact"];
